const actions = {
  REQUESTING: 'ProtocolHistory/REQUESTING',
  RESPONSE_ERROR: 'ProtocolHistory/RESPONSE_ERROR',

  SAVE_PROTOCOLHISTORY: 'ProtocolHistory/SAVE_PROTOCOLHISTORY',
  SAVE_PROTOCOLHISTORY_RECEIVED: 'ProtocolHistory/SAVE_PROTOCOLHISTORY_RECEIVED',
  SAVE_PROTOCOLHISTORY_RESET_RESULT: 'ProtocolHistory/SAVE_PROTOCOLHISTORY_RESET_RESULT',
  SAVE_PROTOCOLHISTORY_RESET_RESULT_RECEIVED:
    'ProtocolHistory/SAVE_PROTOCOLHISTORY_RESET_RESULT_RECEIVED',
}

export default actions
